import { createContext, useContext } from "react";
import { parseTableEnvironment } from "../utils.js";

const TableContext = createContext(undefined);

export function TableProvider({ tableData, tableNode, tabularNode, directTableChild, view, children }) {
    const positions = {
        cells: tableData.cellPositions,
        columnDeclarations: tableData.specification,
        rowPositions: tableData.rowPositions,
        tabular: { from: tabularNode.from, to: tabularNode.to },
    };

    return (
        <TableContext.Provider
            value={{
                ...tableData,
                positions,
                tableEnvironment: tableNode ? parseTableEnvironment(tableNode) : undefined,
                rows: tableData.table.rows.length,
                columns: tableData.table.columns.length,
                directTableChild,
            }}
        >
            {children}
        </TableContext.Provider>
    );
}

export function useTableContext() {
    const context = useContext(TableContext);
    if (context === undefined) {
        throw new Error("useTableContext must be used within a TableProvider");
    }
    return context;
}
